import Model from 'flarum/common/Model';
import type Client from './Client';

export default class Record extends Model {
  client = Model.hasOne<Client>('client');
  user_id = Model.attribute<number>('user_id');
  authorized_at = Model.attribute<Date, string>('authorized_at', Model.transformDate);
}
